const Warehouse = () => import("../warehouse/views/Warehouse.vue");

export default [
  {
    path: "/inventory/warehouse",
    name: "inventory.warehouse.list",
    component: Warehouse,
    meta: { roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"] },
  },
];
